/*------------------------------------*\
    measurements
\*------------------------------------*/
module.exports = function(){




    var _clickedAlterationOrderId = false;
    $(document).on('click', '.js-alterpopup-whole-order-trigger', function(event) {
        event.preventDefault();
        //_clickedAlterationOrderItemId = false;
        _clickedAlterationOrderId = parseInt( $(this).attr('data-oms-order-id') );
        //alertify.log(_clickedAlterationOrderId);
    });


    //var _clickedAlterationOrderItemId = false;
    //$(document).on('click', '.js-alterpopup-trigger', function(event) {
    //    event.preventDefault();
    //    _clickedAlterationOrderId = false;
    //    _clickedAlterationOrderItemId = parseInt( $(this).attr('data-oms-order-item-id') );
    //    alertify.log(_clickedAlterationOrderItemId);
    //});



    /*------------------------------------*\
    \*------------------------------------*/

    var setupParsley = function(){

        if ( $('[js-receipt-upload-form]').length ) {
            $('[js-receipt-upload-form]').parsley();
        }


        if ( $('[js-add-alteration-form]').length ) {
            $('[js-add-alteration-form]').parsley();
        }
    };







    /*------------------------------------*\
    \*------------------------------------*/

    var bothFormsValidation = function(){

        $('[js-receipt-upload-form]').parsley().validate();
        $('[js-add-alteration-form]').parsley().validate();


        if (!$('[js-receipt-upload-form]').parsley().isValid()) {
            return false;
        }

        if (!$('[js-add-alteration-form]').parsley().isValid()) {
            return false;
        }

        return true;
    };











    /*------------------------------------*\
        click on trigger
    \*------------------------------------*/
    $(document).on('click', '.js-alterpopup-whole-order-trigger', function(event) {

        $.magnificPopup.open({
            items: {
                src: $('#alterpopup'),
            },
            mainClass: 'mfp-zoom-in  mfp-alterpopup',
            type: 'inline',
            removalDelay: 500,
            preloader: false,
            showCloseBtn: true,
            closeOnBgClick: false,
            callbacks: {
                open: function() {
                    setupParsley();
                    $('[js-alterpopup-order-id-title]').text(_clickedAlterationOrderId);
                },

                close: function() {

                    $('[js-alteration-popup-window]').find('input').each(function(index,el){
                        $(this).val('');
                    });

                    $('[js-alteration-popup-window]')
                        .find('.js-form-callback')
                        .text('')
                        .removeClass('is-visible')
                        .removeClass('is-error')
                        .removeClass('is-success');

                }
            }
        });

    });








    /*------------------------------------*\
    \*------------------------------------*/
    //var initMagnificPopup = function(){
//
    //    $('.js-alterpopup-trigger, .js-alterpopup-whole-order-trigger').magnificPopup({
//
    //};
//
    //initMagnificPopup();









    /*------------------------------------*\
    \*------------------------------------*/

    $('[js-receipt-upload-form]').on('submit', function(event) {
        event.preventDefault();
    });



    /*var uploadReceiptAjax = new $.Deferred();*/




    var uploadReceipt = function(options){

        var $form = $('[js-receipt-upload-form]');
        var $formSecond = $('[js-add-alteration-form]');
        var submitBtn = $formSecond.find('button[type="submit"]');

        $form.find('.js-receipt-file-callback').removeClass('is-visible');
        $form.find('.js-fff-file-callback').removeClass('is-visible');

        $formSecond.find('.js-form-callback').removeClass('is-visible');

        if ( bothFormsValidation() ) {

            var requestData = new FormData();
            $( $form.serializeArray() ).each(function(index, el) {
                requestData.append(el.name, el.value);
            });
            requestData.append('receipt', $form.find('[js-receipt-file-input]')[0].files[0] );
            requestData.append('fff', $form.find('[js-fff-file-input]')[0].files[0] );

            $.ajax({
                type: $form.attr('method'),
                url: $form.attr('action'),
                data: requestData,
                processData: false,
                contentType: false,
                success: function(data, textStatus, jqXHR) {

                    var json = false;

                    try {

                        json = $.parseJSON(data);

                    } catch (e) {

                        if (jqXHR.responseJSON) {

                            $formSecond.find('.js-form-callback')
                                .text(jqXHR.responseJSON.msg ? jqXHR.responseJSON.msg : 'Something went wrong...' )
                                .addClass('is-visible')
                                .addClass('is-error')
                                .removeClass('is-success');

                        }

                        $formSecond.find('.js-form-callback')
                            .html('Something went wrong...')
                            .addClass('is-visible')
                            .removeClass('is-error')
                            .addClass('is-sucess');

                        submitBtn.text('Retry');
                    }

                    if (json) {
                        if (options.success) { options.success.call(this, data, textStatus, jqXHR); }
                    }



                },
                error: function(jqXHR, textStatus, errorThrown){

                    console.log(jqXHR.responseText);

                    try {

                        var responseTextJson = $.parseJSON(jqXHR.responseText);

                        if (responseTextJson && responseTextJson.receipt_error) {
                            $form.find('.js-receipt-file-callback').text(responseTextJson.receipt_error)
                            .addClass('is-visible')
                            .addClass('is-error');
                        }

                        if (responseTextJson && responseTextJson.fff_error) {
                            $form.find('.js-fff-file-callback').text(responseTextJson.fff_error)
                            .addClass('is-visible')
                            .addClass('is-error');
                        }

                    } catch (e) {
                        console.log(e);
                    }


                    if (jqXHR.responseJSON) {

                        $formSecond.find('.js-form-callback')
                            .text(jqXHR.responseJSON.msg ? jqXHR.responseJSON.msg : 'Something went wrong...' )
                            .addClass('is-visible')
                            .addClass('is-error')
                            .removeClass('is-success');


                    }

                    $formSecond.find('.js-form-callback')
                        .text('Something went wrong...')
                        .addClass('is-visible')
                        .addClass('is-error')
                        .removeClass('is-success');

                    submitBtn.text('Retry');

                },
            });

        }


    };





    var addAlteration = function(options) {

        var $form = $('[js-add-alteration-form]');
        var submitBtn = $form.find('button[type="submit"]');

        if (  bothFormsValidation() ) {

            var action = EPH_API_URL + '/wa-customers/' + globalCustomerId + '/submitAlteration';

            var requestData = {
                'Message': $form.find('input[name="Message"]').val(),
                'ReceiptUrl': options.receipt_url,
                'ImageUrl': options.image_url,
            };

            // is for whole order
            //if (_clickedAlterationOrderId) {
                requestData.IsOrderAlteration = 1;
                requestData.OmsOrderId = _clickedAlterationOrderId;
            //}

            // is for specific product
            //else {
            //    requestData.IsOrderAlteration = false;
            //    requestData.OmsOrderItemId = _clickedAlterationOrderItemId;
            //}

            $.ajax({
                type: $form.attr('method'),
                url: action,
                data: requestData,
                dataType: 'json',
                headers: {
                    Authorization: 'Bearer ' + Cookies.get('JWT_ACCESS_TOKEN'),
                    Accept: 'application/json',
                },
                success: function(data, textStatus, jqXHR) {
                    if (options.success) { options.success.call(this, data, textStatus, jqXHR); }
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    if (options.error) { options.error.call(this, jqXHR, textStatus, errorThrown); }
                }
            });

        }


    };








    /*------------------------------------*\
    \*------------------------------------*/
    $(document).on('submit', '[js-add-alteration-form]', function(event) {
        event.preventDefault();

        if ($('[js-receipt-file-input]')[0].files[0].size / 1024 / 1024 > 5) {
            alertify.error('Maximum receipt file size is 5mb - please resize the image and try again!')
            return false;
        }
        if ($('[js-fff-file-input]')[0].files[0].size / 1024 / 1024 > 5) {
            alertify.error('Maximum file size is 5mb - please resize the image and try again!')
            return false;
        }

        if (
            $('[js-receipt-file-input]')[0].files[0].type.split('/')[0] != 'image' &&
            $('[js-receipt-file-input]')[0].files[0].type.split('/')[0] != 'text' &&
            $('[js-receipt-file-input]')[0].files[0].type.split('/')[1] != 'pdf'
        ) {
            alertify.error('The receipt you tried to upload is not a supported file - please make sure you upload a supported image/pdf/text file!')
            return false;
        }
        if ($('[js-fff-file-input]')[0].files[0].type.split('/')[0] != 'image') {
            alertify.error('The file you tried to upload is not a supported image file - please make sure you upload a supported image file!')
            return false;
        }

        var $form = $(this);
        var submitBtn = $form.find('button[type="submit"]');

        if ( bothFormsValidation() ) {

            submitBtn.text('Sending...');

            uploadReceipt({
                success: function(data, textStatus, jqXHR){

                    var json_data = $.parseJSON(data);

                    //console.log(json_data);

                    if (json_data.fff_success && json_data.receipt_success) {


                        addAlteration({
                            'image_url': json_data.fff_url,
                            'receipt_url': json_data.receipt_url,


                            success: function(data, textStatus, jqXHR){

                                $form.find('.js-form-callback')
                                    .text(data.msg)
                                    .addClass('is-visible')
                                    .removeClass('is-error')
                                    .addClass('is-success');


                                //submitBtn.remove();

                                //$.magnificPopup.close();

                                alertify.alert('Thank you! Alteration request was submitted successfully. We will now reload the page for you so you can see the status of it in your profile.', function(){
                                    document.location.reload();
                                });



                            },

                            error: function(jqXHR, textStatus, errorThrown){

                                if (jqXHR.responseJSON) {
                                    $form.find('.js-form-callback')
                                        .text(jqXHR.responseJSON.msg ? jqXHR.responseJSON.msg : 'Something went wrong...' )
                                        .addClass('is-visible')
                                        .addClass('is-error')
                                        .removeClass('is-success');
                                }

                                $form.find('.js-form-callback')
                                    .text('Something went wrong...')
                                    .addClass('is-visible')
                                    .removeClass('is-error')
                                    .addClass('is-sucess');

                                submitBtn.text('Retry');
                            },

                        });


                    }


                },
            });

        }


        //addAlteration({
        //    receipt_url: 'https://eph-wp.dev/wp-content/uploads/2016/08/sameproducts.png',
        //});

    });








    // hax0r
    $(document).on('click', '[js-add-alteration-form-btn]', function(event) {
        $('[js-receipt-upload-form]').parsley().validate();
        $('[js-add-alteration-form]').parsley().validate();
    });




    /*------------------------------------*\
    \*------------------------------------*/

    /*
    uploadReceiptAjax.done(function(data, textStatus, jqXHR) {
        console.log('-------- START deferred upload receipt ajax done ------------');
        console.log(data);
        console.log(textStatus);
        console.log(jqXHR);
        console.log('-------- ENDOF deferred upload receipt ajax done ------------');
    });
    */


    /*------------------------------------*\
    \*------------------------------------*/


    /*


    - Alterations Modal for each order item when alterations is clicked for that particular order item

    - Alterations For each form submission, we need a Message, ReceiptUrl (uploaded to WP uploads folder), OmsOrderItemId (which is the Id of the OrderItem under the shown Order)

    - Alterations When listing orders, the order item object will have the alteration object when found and will always have the Status of the alteration request


    Submit Alteration API call on WP

    POST /api/v1/wa-customers/{wa_customer_id}/submitAlteration

    Authorization: Bearer JWTTOKEN
    Content-Type: application/json

    {
        "OmsOrderItemId": "103713",
        "Message": "Test Message!",
        "ReceiptUrl": "https://upload.wikimedia.org/wikipedia/commons/0/0b/ReceiptSwiss.jpg"
    }





    // Submit Alteration (POST https://eph-wa.d3.dashagencydev.com/api/v1/wa-customers/52/submitAlteration)

    jQuery.ajax({
        url: "https://eph-wa.d3.dashagencydev.com/api/v1/wa-customers/52/submitAlteration",
        type: "POST",
        headers: {
            "Authorization": "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOjUyLCJpc3MiOiJodHRwczpcL1wvZXBoLXdhLmQzLmRhc2hhZ2VuY3lkZXYuY29tXC9hcGlcL3YxXC9jdXN0b21lcnNcL2F1dGhcL2xvZ2luIiwiaWF0IjoxNDcxNjMxNjc2LCJleHAiOjE0NzI4NDEyNzYsIm5iZiI6MTQ3MTYzMTY3NiwianRpIjoiM2NhNjZiYTI2Y2Q2MzYyZGJlMTMxMGQ2ZDRlYWQ5NGMifQ.gde_ukeTRCFXV3LllA3uepaiYgvnZD1Jm80u-qpzliA",
            "Content-Type": "application/json",
        },
        contentType: "application/json",
        data: JSON.stringify({
            "Message": "Test Message!",
            "OmsOrderItemId": "103713",
            "ReceiptUrl": "https://upload.wikimedia.org/wikipedia/commons/0/0b/ReceiptSwiss.jpg"
        })
    })
    .done(function(data, textStatus, jqXHR) {
        console.log("HTTP Request Succeeded: " + jqXHR.status);
        console.log(data);
    })
    .fail(function(jqXHR, textStatus, errorThrown) {
        console.log("HTTP Request Failed");
    })
    .always(function() {
    });

    */




}; // end of module.exports



// WEBPACK FOOTER //
// ./js-source/integration/alterations.js